import { memo, useMemo } from "react";
import { Button } from "@/core/components/ui/button/button";
import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface UnattributedReviewsFilterCardProps {
  isHeaderAtFullWidth: boolean;
  onFilterClick: () => void;
  isActive: boolean;
}

export const UnattributedReviewsFilterCard = memo(
  ({
    isHeaderAtFullWidth,
    onFilterClick,
    isActive,
  }: UnattributedReviewsFilterCardProps) => {
    const description = useMemo(
      () =>
        isActive
          ? "You are currently viewing unattributed five-star reviews."
          : "View five-star reviews that haven't been attributed to a team member yet.",
      [isActive],
    );

    return (
      <Card
        className={cn("w-full p-4", {
          "border-l-4 border-l-gold-20 transition-all duration-200": isActive,
        })}
      >
        <Stack
          align="center"
          gap="md"
          className={cn("flex-row", {
            "flex-col items-start": isHeaderAtFullWidth,
          })}
          fullWidth
        >
          <Stack gap="xs" fullWidth>
            <Typography variant="subtitleW3" className="text-gold-40">
              Unattributed Five-star Reviews
            </Typography>
            <Typography variant="bodyW2" textColor="secondary">
              {description}
            </Typography>
          </Stack>
          <Button
            variant="secondary"
            size="sm"
            onClick={onFilterClick}
            className="flex-shrink-0"
          >
            {isActive ? "See all activity" : "View Five-star Reviews"}
          </Button>
        </Stack>
      </Card>
    );
  },
);

UnattributedReviewsFilterCard.displayName = "UnattributedReviewsFilterCard";
